class popupHelper {

    constructor() {
        document.addEventListener('DOMContentLoaded', () => this.init());
    }

    async init() {
        let popup;
        try {
            const response = await fetch('/Popups/current');
            const data = await response.json();
            if (data.status !== 'success' || !data.popup) return;
            popup = data.popup;
        } catch (e) {
            return;
        }

        const dismissed = this._getDismissedPopups();
        if (dismissed.includes(popup.id)) return;

        document.getElementById('site-popup-modal-title').textContent       = popup.title ?? '';
        document.getElementById('site-popup-modal-description').textContent = popup.description ?? '';

        const galleryEl = document.getElementById('site-popup-modal-gallery');
        const imgLinkEl = document.getElementById('site-popup-modal-image-link');
        const imgEl     = document.getElementById('site-popup-modal-image');
        if (popup.image_url) {
            imgEl.src      = popup.image_url;
            imgEl.alt      = popup.title ?? '';
            imgLinkEl.href = popup.image_url;
            galleryEl.classList.remove('d-none');
            lightGallery(galleryEl, { speed: 400 });
        } else {
            galleryEl.classList.add('d-none');
        }

        const btnEl = document.getElementById('site-popup-button');
        if (popup.button_text && popup.button_url) {
            btnEl.textContent = popup.button_text;
            btnEl.href        = popup.button_url;
            btnEl.classList.remove('d-none');
        } else {
            btnEl.classList.add('d-none');
        }

        const modalEl = document.getElementById('site-popup-modal');
        modalEl.addEventListener('hidden.bs.modal', () => {
            const checkbox = document.getElementById('site-popup-do-not-show-again');
            if (checkbox && checkbox.checked) {
                this._addDismissedPopup(popup.id);
            }
            // Reset checkbox for next time the modal might be shown on this page
            if (checkbox) checkbox.checked = false;
        }, { once: true });

        bootstrap.Modal.getOrCreateInstance(modalEl).show();
    }

    _getDismissedPopups() {
        try {
            return JSON.parse(localStorage.getItem('dismissed_popups') ?? '[]');
        } catch (e) {
            return [];
        }
    }

    _addDismissedPopup(id) {
        const list = this._getDismissedPopups();
        if (!list.includes(id)) {
            list.push(id);
            localStorage.setItem('dismissed_popups', JSON.stringify(list));
        }
    }
}

export let PopupHelper = new popupHelper();
